
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/7-questions-for-trees-for-the-future",
      function () {
        return require("private-next-pages/blog/7-questions-for-trees-for-the-future.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/7-questions-for-trees-for-the-future"])
      });
    }
  